export function initIntersectionObserver(target, func) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    func(target);

                    observer.unobserve(target);
                }
            });
        },
        {
            rootMargin: "0px 0px 150px 0px",
            threshold: 0,
        },
    );

    if (!target.classList.contains("observer-initialized")) {
        observer.observe(target);
        target.classList.add("observer-initialized");
    }
}
